import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Review = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 40 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M19.2838 2.33325C19.6763 1.93103 20.323 1.93103 20.7154 2.33325L22.2455 3.90156C22.5454 4.20895 23.0081 4.29053 23.395 4.10425L25.3693 3.15385C25.8756 2.91011 26.4833 3.13129 26.7145 3.64347L27.6159 5.64053C27.7926 6.03195 28.1995 6.26686 28.6268 6.22416L30.807 6.0063C31.3662 5.95043 31.8616 6.36612 31.9036 6.92648L32.0677 9.11142C32.0998 9.53966 32.4018 9.89956 32.818 10.0056L34.9412 10.5466C35.4858 10.6853 35.8091 11.2453 35.657 11.7863L35.0639 13.8956C34.9476 14.309 35.1083 14.7505 35.4631 14.9924L37.2733 16.227C37.7375 16.5436 37.8498 17.1805 37.5219 17.6368L36.2431 19.416C35.9924 19.7647 35.9924 20.2345 36.2431 20.5832L37.5219 22.3624C37.8498 22.8188 37.7375 23.4556 37.2733 23.7722L35.4631 25.0068C35.1083 25.2487 34.9476 25.6902 35.0639 26.1036L35.657 28.2129C35.8091 28.7539 35.4858 29.3139 34.9412 29.4527L32.818 29.9936C32.4018 30.0997 32.0998 30.4596 32.0677 30.8878L31.9036 33.0727C31.8616 33.6331 31.3662 34.0488 30.807 33.9929L28.6268 33.7751C28.1995 33.7324 27.7926 33.9673 27.6159 34.3587L26.7145 36.3558C26.4833 36.8679 25.8756 37.0891 25.3693 36.8454L23.395 35.895C23.0081 35.7087 22.5454 35.7903 22.2455 36.0977L20.7154 37.666C20.323 38.0682 19.6763 38.0682 19.2838 37.666L17.7537 36.0977C17.4538 35.7903 16.9911 35.7087 16.6042 35.895L14.63 36.8454C14.1236 37.0891 13.5159 36.8679 13.2848 36.3558L12.3833 34.3587C12.2066 33.9673 11.7998 33.7324 11.3724 33.7751L9.1922 33.9929C8.63305 34.0488 8.13765 33.6331 8.09558 33.0727L7.93154 30.8878C7.89938 30.4596 7.59739 30.0997 7.18123 29.9936L5.05798 29.4527C4.51343 29.3139 4.19009 28.7539 4.34221 28.2129L4.93535 26.1036C5.0516 25.6902 4.89092 25.2487 4.53612 25.0068L2.72593 23.7722C2.26168 23.4556 2.14938 22.8188 2.47735 22.3624L3.75613 20.5832C4.00677 20.2345 4.00677 19.7647 3.75613 19.416L2.47735 17.6368C2.14938 17.1805 2.26168 16.5436 2.72593 16.227L4.53612 14.9924C4.89092 14.7505 5.0516 14.309 4.93535 13.8956L4.34221 11.7863C4.19009 11.2453 4.51343 10.6853 5.05798 10.5466L7.18123 10.0056C7.59739 9.89956 7.89938 9.53966 7.93154 9.11142L8.09558 6.92648C8.13765 6.36612 8.63305 5.95043 9.1922 6.0063L11.3724 6.22416C11.7998 6.26686 12.2066 6.03195 12.3833 5.64053L13.2848 3.64347C13.5159 3.13129 14.1236 2.91011 14.63 3.15385L16.6042 4.10425C16.9911 4.29053 17.4538 4.20895 17.7537 3.90156L19.2838 2.33325Z"
        fill="url(#paint0_linear_6458_24646)"
      />
      <g filter="url(#filter0_di_6458_24646)">
        <path
          d="M24.6639 12.6063C25.2126 11.6478 26.435 11.3155 27.3936 11.8642C28.3522 12.4129 28.6845 13.6352 28.1358 14.5938L20.8092 27.3938C20.5064 27.9228 19.9788 28.2843 19.3764 28.3767C18.7737 28.4688 18.1611 28.2817 17.7139 27.8673L12.2405 22.7938L12.0967 22.647C11.4271 21.8863 11.429 20.7266 12.1327 19.9673C12.8834 19.1573 14.1491 19.109 14.9592 19.8595L18.5874 23.222L24.6639 12.6063Z"
          fill="white"
          fillOpacity="0.87"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_6458_24646"
          x="7.59961"
          y="11.5996"
          width="24.8008"
          height="24.7998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6458_24646" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6458_24646" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.1" dy="0.1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_6458_24646" />
        </filter>
        <linearGradient
          id="paint0_linear_6458_24646"
          x1="19.9996"
          y1="1.59961"
          x2="19.9996"
          y2="38.3996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#04AF00" />
          <stop offset="1" stopColor="#037D00" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Review
